import {
  SHOWCASE_STATUS_AGREEMENT,
  SHOWCASE_STATUS_DRAFT,
  SHOWCASE_STATUS_REJECTED,
  SHOWCASE_STATUS_REMOVED,
  SHOWCASE_STATUS_REVISION,
  SHOWCASE_STATUS_ID_AGREEMENT,
  SHOWCASE_STATUS_ID_DRAFT,
  SHOWCASE_STATUS_ID_PUBLISHED,
  SHOWCASE_STATUS_ID_REJECTED,
  SHOWCASE_STATUS_ID_REMOVED,
  SHOWCASE_STATUS_ID_REVISION,
} from '@/api/models/ProjectShowcaseStatus';

export const getShowcaseVisibleStatusForLeader = (statusId) => {
  switch (statusId) {
    case SHOWCASE_STATUS_ID_DRAFT:
      return {
        type: SHOWCASE_STATUS_DRAFT,
        text: 'Черновик',
        actionLabel: 'Требуется согласование публикации проекта',
        description: '',
      };
    case SHOWCASE_STATUS_ID_REVISION:
      return {
        type: SHOWCASE_STATUS_REVISION,
        text: 'Обновление',
        actionLabel: 'Требуется согласование публикации проекта',
        description: '',
      };
    case SHOWCASE_STATUS_ID_AGREEMENT:
      return {
        type: SHOWCASE_STATUS_AGREEMENT,
        text: 'На согласовании',
        actionLabel: 'Согласовать публикацию проекта с администратором',
        description: '',
      };
    case SHOWCASE_STATUS_ID_PUBLISHED:
      return {
        type: SHOWCASE_STATUS_AGREEMENT,
        text: 'Согласовано',
        actionLabel: 'Согласовать публикацию проекта с администратором',
        description: '',
      };
    case SHOWCASE_STATUS_ID_REJECTED:
      return {
        type: SHOWCASE_STATUS_REJECTED,
        text: 'Отклонено',
        actionLabel: 'Согласовать публикацию проекта с администратором',
        description: '',
      };
    case SHOWCASE_STATUS_ID_REMOVED:
      return {
        type: SHOWCASE_STATUS_REMOVED,
        text: 'Отозвано',
        actionLabel: 'Согласовать публикацию проекта с администратором',
        description: '',
      };
    default:
      return {
        type: 'undefined',
        text: 'Undefined',
        actionLabel: 'Undefined',
        description: '',
      };
  }
};
